import { render } from "./SetUp.vue?vue&type=template&id=2a545bd8&scoped=true"
import script from "./SetUp.vue?vue&type=script&lang=js"
export * from "./SetUp.vue?vue&type=script&lang=js"

import "./SetUp.vue?vue&type=style&index=0&id=2a545bd8&scoped=true&lang=css"

import exportComponent from "D:\\perject\\suyuan\\eshop-vant4-vue3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a545bd8"]])

export default __exports__